/**
 * created by yxy
 *
 */

import del from '../images/del.png'
import logout from '../images/logout.png'
import update from '../images/update.png'
import add from '../images/add.png'
import nianshen from '../images/nianshen.png'
export const picList=[
    {
      name:'新增',
       src:add
    },
    {
        name:'更新',
        src:update
    },
    {
        name:'注销',
        src:logout
    },
    {
        name:'删除',
        src:del
    },
    {
        name:'年审',
        src:nianshen
    }
];
export const statisticsList=[
    {
        key:'activatingCount',
        name:'近期活跃',
        color:'#b684f2'
    },
    {
        key:'recordingCount',
        name:'审核中',
        color:'#ffb038',
    },
    {
        key:'recordedCount',
        name:'已备案',
        color:'#89d069',
    },

];
export const typeList=[
    {
        key:'1',
        name:'近期活跃',
        color:'#b684f2'
    },
    {
        key:'2',
        name:'审核中',
        color:'#ffb038',
    },
    {
        key:'3',
        name:'已备案',
        color:'#89d069',
    },

];